import ContactList from "../../ContactList/ContactList";
import styled from "styled-components";
import { FC } from "react";

interface IAudience {
  tabType?: string;
  page?: string;
  title?: string;
  tab?: string;
}

const Audience: FC<IAudience> = (props) => {
  return (
    <Wrapper>
      <div className="wrapper-box">
        <div className="margin-top-contact-list">
          <ContactList isAudiencePage />
        </div>
      </div>
      {/* <CampaignAudienceOnBoarding /> */}
    </Wrapper>
  );
};

export default Audience;

const Wrapper = styled.div`
  .wrapper-box {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    .margin-top-contact-list {
      /* position: relative;
      z-index: 1; */
    }
  }
  .message-wrapper {
    margin-bottom: 138px;
  }
`;
